import { render, staticRenderFns } from "./SubmissionFormSelector.vue?vue&type=template&id=8028588a&"
import script from "./SubmissionFormSelector.vue?vue&type=script&lang=js&"
export * from "./SubmissionFormSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports